import { notifications } from "@mantine/notifications"

import { queryClient } from "~/backend/queryClient"
import {
  findOperationChainItemsQueryKey,
  useCreateOperationChainItem,
} from "~/gen/api"
import { showAxiosError } from "~/utils/showAxiosError"

export const useCreateOperationChainItemMutation = () =>
  useCreateOperationChainItem({
    mutation: {
      onSuccess: async (_, variables) => {
        await queryClient.invalidateQueries(
          findOperationChainItemsQueryKey(variables.operationChainId)
        )
        notifications.show({
          title: "Success",
          message: "Operation chain item created",
          color: "teal",
        })
      },
      onError: (error) => {
        showAxiosError({
          error,
          showNotification: true,
          defaultMessage: "Failed to add operation chain item",
          notificationTitle: "Failed to add operation chain item",
        })
      },
    },
  })
